<template>
	<DjBox class="h-[500px] overflow-hidden">
		<img class="w-full h-full object-cover" :src="buildImgSrc(address)" alt="maps" />
		<div
			class="h-[140px] absolute left-2 right-2 md:left-5 md:right-5 bottom-5 border border-dj-gray-light rounded-normal pt-2 px-4 pb-4 md:pt-5 md:px-8 md:pb-8 bg-white z-10"
			:class="isOverFlowYScroll"
		>
			<h3 class="text-lg md:text-xl font-medium mb-2">{{ title }}</h3>
			<a class="relatative flex flex-col w-full" :href="buildMapsLink(address)" target="_blank">
				<span class="text-sm">{{ address.formatted_address }}</span>
			</a>
			<div v-if="otherAddresses && otherAddresses[1] != undefined">
				<div class="text-sm mt-5 font-medium text-dj-blue cursor-pointer" @click="toggleOtherOffices">
					{{ otherOfficesText }}
				</div>
				<div :class="isShowOtherOffices">
					<div v-for="(item, index) in otherAddresses.slice(1)" :key="index">
						<span class="text-sm">{{ item.formatted_address }}</span>
						<br />
					</div>
				</div>
			</div>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import DjBox from "~/ui-kit/components/box/DjBox.vue";

export default defineComponent({
	name: "DjBoxMap",
	components: { DjBox },
	props: {
		title: {
			type: String,
			default: "",
		},
		markerUrl: {
			type: String,
			default: "",
		},
		address: {
			type: Object,
			required: true,
		},
		otherAddresses: {
			type: Object,
			required: false,
		},
		otherOfficesText: {
			type: String,
			default: "További irodák",
		},
		apiUrl: {
			type: String,
			default: "",
		},
	},
	setup(props: object) {
		const isShowOtherOffices = ref("hidden");
		const isOverFlowYScroll = ref("overflow-hidden");

		function toggleOtherOffices() {
			isShowOtherOffices.value = isShowOtherOffices.value == "" ? "hidden" : "";
			isOverFlowYScroll.value =
				isOverFlowYScroll.value == "overflow-hidden" ? "overflow-y-scroll" : "overflow-hidden";
		}

		function buildMapsLink(address: Record<string, string>) {
			return `https://www.google.com/maps/place/${address.formatted_address}/@${address.lat},${address.lng}`;
		}

		function buildImgSrc(address: Record<string, string>) {
			return (
				props.apiUrl +
				`/staticmap?center=${address.lat},${address.lng}&zoom=14&size=400x400&markers=icon:${props.markerUrl}|${address.lat},${address.lng}`
			);
		}

		return {
			buildMapsLink,
			buildImgSrc,
			toggleOtherOffices,
			isShowOtherOffices,
			isOverFlowYScroll,
		};
	},
});
</script>
